import { CustomerStatusType } from '../customer/types/customerStatusType';
import {
  CanCreateOrderForCustomerParams,
  GetAllowedCustomerStatusToCreateOrderParams,
} from './orderCreation.types';

const ALL_CUSTOMER_STATUS = Object.values(CustomerStatusType);

export const getAllowedCustomerStatusToCreateOrder = ({
  allowBlockedCustomerToCreateOrder = false,
}: GetAllowedCustomerStatusToCreateOrderParams): CustomerStatusType[] => {
  const notAllowedStatusToCreate = [
    CustomerStatusType.INACTIVE,
    ...(!allowBlockedCustomerToCreateOrder ? [CustomerStatusType.BLOCKED] : []),
  ];

  return ALL_CUSTOMER_STATUS.filter((status) => !notAllowedStatusToCreate.includes(status));
};

export const canCreateOrderForCustomer = ({
  ability,
  customerStatus,
  allowBlockedCustomerToCreateOrder,
}: CanCreateOrderForCustomerParams): boolean => {
  if (!ability || !customerStatus) {
    return false;
  }

  return (
    ability.can('create', 'orders') &&
    getAllowedCustomerStatusToCreateOrder({ allowBlockedCustomerToCreateOrder }).includes(
      customerStatus,
    )
  );
};
